const stockFeatures = [
  {
    icon: 'ri-flashlight-line',
    title: 'Registro Flash',
    desc: 'Sube productos fácil y rápido. Sin procesos complicados, sin fricción.',
    badge: null,
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Alertas Inteligentes',
    desc: 'El sistema te avisa si queda poco stock. Nunca pierdas ventas por desabastecimiento.',
    badge: null,
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Reportes Visuales',
    desc: 'Conoce tus márgenes y el valor de tu inventario con un clic. Datos claros al instante.',
    badge: null,
  },
  {
    icon: 'ri-global-line',
    title: '100% Sincronizado',
    desc: 'Entra desde celular, tablet o laptop 24/7. Tu negocio en la palma de tu mano.',
    badge: null,
  },
  {
    icon: 'ri-robot-line',
    title: 'IA Integrada',
    desc: 'Consulta a la inteligencia artificial y obtén un análisis rápido de tu inventario, tendencias de stock y recomendaciones en segundos.',
    badge: 'NUEVO',
  },
  {
    icon: 'ri-file-pdf-line',
    title: 'Exportación a PDF Profesional',
    desc: 'Genera reportes en PDF con diseño profesional listos para presentar a socios, contadores o inversores con un solo clic.',
    badge: 'NUEVO',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Soporte y Actualizaciones Constantes',
    desc: 'Equipo de soporte siempre disponible. Recibes mejoras y nuevas funciones automáticamente sin costo adicional.',
    badge: 'NUEVO',
  },
];

const budgetFeatures = [
  {
    icon: 'ri-smartphone-line',
    title: 'Movilidad Total',
    desc: 'Úsalo en Celular, PC o Tablet. Registra en la nube desde donde estés.',
    badge: null,
  },
  {
    icon: 'ri-time-line',
    title: 'Cero Fricción',
    desc: 'Adiós al Excel. Registra tus movimientos en 3 clics. Simple y poderoso.',
    badge: null,
  },
  {
    icon: 'ri-pie-chart-2-line',
    title: 'Radiografía Visual',
    desc: 'Gráficos automáticos para detectar y cortar tus fugas de dinero rápido.',
    badge: null,
  },
  {
    icon: 'ri-robot-line',
    title: 'IA Integrada',
    desc: 'Pídele a la IA un resumen financiero instantáneo: detecta gastos vampiro, patrones de gasto y oportunidades de ahorro sin esfuerzo.',
    badge: 'NUEVO',
  },
  {
    icon: 'ri-file-pdf-line',
    title: 'Exportación a PDF Profesional',
    desc: 'Descarga tus reportes financieros en formato PDF profesional para compartir con tu equipo o tomar decisiones con datos reales.',
    badge: 'NUEVO',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Soporte y Actualizaciones Constantes',
    desc: 'Soporte real con personas reales. Además recibes todas las actualizaciones futuras incluidas en tu plan sin pagar nada extra.',
    badge: 'NUEVO',
  },
];

interface FeatureItemProps {
  icon: string;
  title: string;
  desc: string;
  badge: string | null;
  color: string;
}

function FeatureItem({ icon, title, desc, badge, color }: FeatureItemProps) {
  return (
    <div className="flex items-start gap-4">
      <div className={`w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-lg bg-${color}/10`}>
        <i className={`${icon} text-lg text-${color}`}></i>
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <p className="text-white font-bold text-base">{title}</p>
          {badge && (
            <span className="text-[10px] font-black px-2 py-0.5 rounded-full bg-[#00FF88]/20 text-[#00FF88] whitespace-nowrap">
              {badge}
            </span>
          )}
        </div>
        <p className="text-gray-400 text-sm mt-0.5">{desc}</p>
      </div>
    </div>
  );
}

export default function Systems() {
  return (
    <section id="sistemas" className="bg-[#080808] py-20 md:py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-[#00FF88] text-sm font-bold uppercase tracking-widest">Lo que obtienes</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mt-3">
            Dos Sistemas. Un Solo Precio.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Stock Simple */}
          <div className="group relative bg-[#111111] rounded-2xl overflow-hidden border border-white/5 hover:border-[#00FF88]/30 transition-all duration-500">
            <div className="h-1.5 w-full bg-gradient-to-r from-[#00FF88] to-[#00cc6a]"></div>
            <div className="p-8 md:p-10">
              <div className="flex items-start gap-4 mb-8">
                <div className="w-14 h-14 flex items-center justify-center bg-[#00FF88]/10 rounded-xl text-3xl flex-shrink-0">
                  📦
                </div>
                <div>
                  <p className="text-[#00FF88] text-xs font-bold uppercase tracking-widest mb-1">Sistema 1</p>
                  <h3 className="text-white text-2xl md:text-3xl font-black">Stock Simple</h3>
                  <p className="text-gray-500 text-sm mt-1 italic">Tu nuevo centro de mando</p>
                </div>
              </div>
              <div className="space-y-5">
                {stockFeatures.map((f, i) => (
                  <FeatureItem key={i} {...f} color="[#00FF88]" />
                ))}
              </div>
              <div className="mt-8 rounded-xl overflow-hidden">
                <img
                  alt="Interfaz Stock Simple"
                  className="w-full h-36 object-cover object-top rounded-xl"
                  src="https://readdy.ai/api/search-image?query=inventory%20management%20software%20dashboard%20interface%20on%20dark%20screen%2C%20product%20list%20with%20stock%20levels%20and%20alerts%2C%20clean%20modern%20UI%20design%20with%20green%20accents%2C%20minimal%20dark%20theme%2C%20professional%20business%20application%20screenshot&width=560&height=280&seq=stock-simple-03&orientation=landscape"
                />
              </div>
              <p className="mt-6 text-[#00FF88] text-center italic text-base font-semibold">
                "Imagina tener todo tu negocio en la palma de tu mano... Suena bien, ¿verdad?"
              </p>
            </div>
          </div>

          {/* Budgettrack */}
          <div className="group relative bg-[#111111] rounded-2xl overflow-hidden border border-white/5 hover:border-[#FF6B35]/30 transition-all duration-500">
            <div className="h-1.5 w-full bg-gradient-to-r from-[#FF6B35] to-[#FF3D00]"></div>
            <div className="p-8 md:p-10">
              <div className="flex items-start gap-4 mb-8">
                <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl text-3xl flex-shrink-0">
                  💰
                </div>
                <div>
                  <p className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest mb-1">Sistema 2</p>
                  <h3 className="text-white text-2xl md:text-3xl font-black">Budgettrack</h3>
                  <p className="text-gray-500 text-sm mt-1 italic">Domina tus números financieros</p>
                </div>
              </div>
              <div className="space-y-5">
                {budgetFeatures.map((f, i) => (
                  <FeatureItem key={i} {...f} color="[#FF6B35]" />
                ))}
              </div>
              <div className="mt-8 rounded-xl overflow-hidden">
                <img
                  alt="Interfaz Budgettrack"
                  className="w-full h-36 object-cover object-top rounded-xl"
                  src="https://readdy.ai/api/search-image?query=financial%20budget%20tracking%20app%20interface%20on%20mobile%20and%20desktop%2C%20expense%20charts%20and%20graphs%20with%20orange%20accents%2C%20clean%20dark%20UI%20design%2C%20income%20expense%20dashboard%2C%20professional%20fintech%20application%20screenshot%2C%20minimal%20modern%20design&width=560&height=280&seq=budgettrack-04&orientation=landscape"
                />
              </div>
              <div className="mt-6 bg-[#FF6B35]/10 border border-[#FF6B35]/20 rounded-xl p-4 text-center">
                <p className="text-gray-400 text-sm">Ambos sistemas juntos por solo</p>
                <p className="text-white text-4xl font-black mt-1">
                  $12 <span className="text-[#FF6B35] text-lg font-semibold">/año</span>
                </p>
                <p className="text-gray-500 text-xs mt-1">Menos de 4 centavos al día</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
